var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dict-select-with-add',_vm._g({attrs:{"dict-type":"MATERIAL_UNIT","value-field":"dictLabel","add-text":"添加单位","label-placeholder":"如：米、平方米","value":_vm.value,"clearable":_vm.clearable,"placeholder":_vm.placeholder,"disabled":_vm.disabled}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }